export type SearchPriorityConfig = {
    relevanceField: SEARCH_FIELD;
    fieldPriorityWeight: number;
    matchScore: number;
};

export enum SEARCH_FIELD {
  TITLE = 'TITLE',
  TAGS = 'TAGS',
  OWNER = 'OWNER',
  ORG_UNIT = 'ORG_UNIT',
  SUBTITLE = 'SUBTITLE',
  DESCRIPTION = 'DESCRIPTION',
  INFORMATION = 'INFORMATION',
  OTHER = 'OTHER',
}

export const FIELD_PRIORITY_WEIGHT: Record<SEARCH_FIELD, number> = {
  TITLE: 5,
  TAGS: 3,
  OWNER: 2,
  ORG_UNIT: 2,
  SUBTITLE: 2,
  DESCRIPTION: 1,
  INFORMATION: 1,
  OTHER: 0,
};
